import { SplitScreenListBody } from '@web/components';
import { List } from '@web/molecules';
import mixedBowlImage from '../../images/product-photos/bowls/mixed_bowl_image-transparent.png';
import freshBowlImage from '../../images/product-photos/bowls/fresh_bowl_image-transparent.png';
import halfFreshBowlImage from '../../images/product-photos/bowls/half_fresh_bowl-transparent.png';
import splitScreenPromoImage from '../../images/our-food/split_screen_promo_image.jpg';
import checkIcon from '../../images/Icons/Check.png';
import beef from '../../images/Icons/Beef.png';
import chicken from '../../images/Icons/Chicken.png';
import lamb from '../../images/Icons/Lamb.png';
import turkey from '../../images/Icons/Turkey.png';
import pork from '../../images/Icons/Pork.png';
import {
  QUIZ_SUBPATH,
  USER_INFO_SLUG,
  PUP_INFO_SLUG,
  BIRTHDAY_SLUG,
  BREED_SLUG,
  CALORIES_SLUG,
  ACTIVITY_SLUG,
  ALLERGIES_SLUG,
  POOP_SLUG,
  MEALPREP_SELECTION_SUBPATH,
  RECOMMENDEDPLAN_SUBPATH,
  RECIPES_SELECTION_SUBPATH,
  RECIPES_FRESH_SLUG,
  RECIPES_DRY_SLUG,
  ADDONS_SELECTION_SUBPATH,
  CHECKOUT_SUBPATH,
  CONFIRMATION_SUBPATH,
  NUTRITION_SLUG,
  ABOUT_SLUG,
  APP_CONFIRMATION_SUBPATH,
  WEIGHT_INTERSTIITAL_SLUG,
} from '../routing';

export const ROOT_SUBPATH = '/onboarding/';

export const levelToLabel = {
  Low: 'mellow',
  Moderate: 'active',
  High: 'very active',
};

export const PRODUCT_TYPES = {
  fresh: 'fresh',
  dry: 'dry',
  mixed: 'mixed',
  half_fresh: 'half_fresh',
};

export const SKU_TO_PLAN = {
  DY: PRODUCT_TYPES.dry,
  FR: PRODUCT_TYPES.fresh,
  MX: PRODUCT_TYPES.mixed,
};

export const DENTAL_CHEWS_SKUS = [
  'SUPP-DENT-XS',
  'SUPP-DENT-SM',
  'SUPP-DENT-MD',
  'SUPP-DENT-LG',
];

export const BEST_SELLER_SKUS = [
  'JERKYSTRIPS-BE',
  'JERKYSTRIPS-SA',
  'BELLYRUBS01',
  'ZOOMIES01',
  ...DENTAL_CHEWS_SKUS,
];

export const PLAN_TO_SKU = {
  dry: 'DY',
  fresh: 'FR',
  mixed: 'MX',
  half_fresh: 'FR',
};

export const ONBOARDING_VARIATIONS = {
  control: 'control',
  required: 'required_questions_only',
  requiredWithBirthday: 'required_questions_with_birthday',
};

export const EXTRAS_VARIATIONS = {
  control: 'control',
  bestSellers: 'best_sellers',
  noPage: 'no_page',
};

export const FRESH_PRODUCT_TYPES = [
  PRODUCT_TYPES.fresh,
  PRODUCT_TYPES.half_fresh,
];

export const STATE = {
  initial: ROOT_SUBPATH,
  userInfo: `${QUIZ_SUBPATH}/${USER_INFO_SLUG}`,
  pupInfo: `${QUIZ_SUBPATH}/${PUP_INFO_SLUG}`,
  birthday: `${QUIZ_SUBPATH}/${BIRTHDAY_SLUG}`,
  breed: `${QUIZ_SUBPATH}/${BREED_SLUG}`,
  calories: `${QUIZ_SUBPATH}/${CALORIES_SLUG}`,
  activity: `${QUIZ_SUBPATH}/${ACTIVITY_SLUG}`,
  allergies: `${QUIZ_SUBPATH}/${ALLERGIES_SLUG}`,
  poop: `${QUIZ_SUBPATH}/${POOP_SLUG}`,
  recommendedPlan: RECOMMENDEDPLAN_SUBPATH,
  planSelection: MEALPREP_SELECTION_SUBPATH,
  fresh: `${RECIPES_SELECTION_SUBPATH}/${RECIPES_FRESH_SLUG}`,
  baked: `${RECIPES_SELECTION_SUBPATH}/${RECIPES_DRY_SLUG}`,
  addons: ADDONS_SELECTION_SUBPATH,
  submitCart: 'submit',
  checkout: CHECKOUT_SUBPATH,
  confirmation: CONFIRMATION_SUBPATH,
  appConfirmation: APP_CONFIRMATION_SUBPATH,
  about: `${QUIZ_SUBPATH}/${ABOUT_SLUG}`,
  nutrition: `${QUIZ_SUBPATH}/${NUTRITION_SLUG}`,
  weightInterstitial: `${QUIZ_SUBPATH}/${WEIGHT_INTERSTIITAL_SLUG}`,
};

export const ACTION_TYPES = {
  initialLoad: 'initialLoad',
  toUserInfo: 'toUserInfo',
  customerInfoSaved: 'customerInfoSaved',
  toPupInfo: 'toPupInfo',
  toBirthday: 'toBirthday',
  toBreed: 'toBreed',
  toCalories: 'toCalories',
  toActivity: 'toActivity',
  toAllergies: 'toAllergies',
  toPoop: 'toPoop',
  toRecommendedPlan: 'toRecommendedPlan',
  toPlanSelection: 'toPlanSelection',
  selectedPlanType: 'selectedPlanType',
  selectedFreshRecipes: 'selectedFreshRecipes',
  selectedBakedRecipes: 'selectedBakedRecipes',
  selectedMixedRecipes: 'selectedMixedRecipes',
  toAddons: 'toAddons',
  toCheckout: 'toCheckout',
  toConfirmation: 'toConfirmation',
  goBack: 'goBack',
  toAbout: 'toAbout',
  toNutrition: 'toNutrition',
  toWeightInterstitial: 'toWeightInterstitial',
};

export const ACTIONS = {
  initialLoad: (payload = {}) => ({
    payload,
    type: ACTION_TYPES.initialLoad,
  }),
  toUserInfo: (payload = {}) => ({
    payload,
    type: ACTION_TYPES.toUserInfo,
  }),
  customerInfoSaved: (payload = {}) => ({
    payload,
    type: ACTION_TYPES.customerInfoSaved,
  }),
  toPupInfo: (payload = {}) => ({
    payload,
    type: ACTION_TYPES.toPupInfo,
  }),
  toBirthday: (payload = {}) => ({
    payload,
    type: ACTION_TYPES.toBirthday,
  }),
  toBreed: (payload = {}) => ({
    payload,
    type: ACTION_TYPES.toBreed,
  }),
  toCalories: (payload = {}) => ({
    payload,
    type: ACTION_TYPES.toCalories,
  }),
  toActivity: (payload = {}) => ({
    payload,
    type: ACTION_TYPES.toActivity,
  }),
  toAllergies: (payload = {}) => ({
    payload,
    type: ACTION_TYPES.toAllergies,
  }),
  toPoop: (payload = {}) => ({
    payload,
    type: ACTION_TYPES.toPoop,
  }),
  // petComplete
  toRecommendedPlan: (payload = {}) => {
    return {
      payload,
      type: ACTION_TYPES.toRecommendedPlan,
    };
  },
  toPlanSelection: (payload = {}) => {
    return {
      payload,
      type: ACTION_TYPES.toPlanSelection,
    };
  },
  selectedPlanType: (payload = {}) => {
    return {
      payload,
      type: ACTION_TYPES.selectedPlanType,
    };
  },
  selectedFreshRecipes: (payload = {}, props) => {
    return {
      payload,
      type: ACTION_TYPES.selectedFreshRecipes,
      props,
    };
  },
  selectedBakedRecipes: (payload = {}, props) => {
    return {
      payload,
      type: ACTION_TYPES.selectedBakedRecipes,
      props,
    };
  },
  selectedMixedRecipes: (payload = {}, props) => {
    return {
      payload,
      type: ACTION_TYPES.selectedMixedRecipes,
      props,
    };
  },
  toAddons: (payload = {}) => ({
    payload,
    type: ACTION_TYPES.toAddons,
  }),
  toCheckout: (payload = {}) => ({
    payload,
    type: ACTION_TYPES.toCheckout,
  }),
  toConfirmation: (payload = {}) => {
    return {
      payload,
      type: ACTION_TYPES.toConfirmation,
    };
  },
  goBack: (payload = {}) => {
    return {
      payload,
      type: ACTION_TYPES.goBack,
    };
  },
  //Shortened Quiz Actions
  toAbout: (payload = {}) => ({
    payload,
    type: ACTION_TYPES.toAbout,
  }),
  toNutrition: (payload = {}) => ({
    payload,
    type: ACTION_TYPES.toNutrition,
  }),
  toWeightInterstitial: (payload = {}) => ({
    payload,
    type: ACTION_TYPES.toWeightInterstitial,
  }),
};

export const pathToAction = {
  [STATE.userInfo]: ACTIONS.toUserInfo,
  [STATE.pupInfo]: ACTIONS.toPupInfo,
  [STATE.birthday]: ACTIONS.toBirthday,
  [STATE.breed]: ACTIONS.toBreed,
  [STATE.calories]: ACTIONS.toCalories,
  [STATE.activity]: ACTIONS.toActivity,
  [STATE.allergies]: ACTIONS.toAllergies,
  [STATE.poop]: ACTIONS.toPoop,
  [STATE.recommendedPlan]: ACTIONS.toRecommendedPlan,
  [STATE.planSelection]: ACTIONS.toPlanSelection,
  [STATE.fresh]: ACTIONS.selectedPlanType,
  [STATE.baked]: ACTIONS.selectedPlanType,
  [STATE.submitCart]: ACTIONS.selectedFreshRecipes,
  [STATE.submitCart]: ACTIONS.selectedBakedRecipes,
  [STATE.submitCart]: ACTIONS.selectedFreshWithExtras,
  [STATE.addons]: ACTIONS.toAddons,
  [STATE.checkout]: ACTIONS.toCheckout,
  [STATE.confirmation]: ACTIONS.toConfirmation,
  [STATE.about]: ACTIONS.toAbout,
  [STATE.nutrition]: ACTIONS.toNutrition,
  [STATE.weightInterstitial]: ACTIONS.toWeightInterstitial,
};

export const STATE_TO_STEP_REFERENCE = {
  [STATE.planSelection]: 0,
  [STATE.fresh]: 1,
  [STATE.baked]: 1,
  [STATE.submitCart]: 1,
  [STATE.addons]: 2,
  [STATE.checkout]: 3,
};

export const STATE_TO_STEP_REFERENCE_RECOMMENDED = {
  [STATE.userInfo]: 0,
  [STATE.recommendedPlan]: 1,
  [STATE.submitCart]: 1,
  [STATE.addons]: 2,
  [STATE.checkout]: 2,
};

export const unmappedStates = [STATE.initial, STATE.submitCart];

export const PLAN_SELECTION_KEY = 'PLAN_SELECTION';

const icon = {
  src: checkIcon,
  alt: 'icon image',
  height: 100,
  width: 100,
};

// Meal Prep CRO Constants
const IllustrationPillsData = [
  {
    component: 'illustration_pill',
    icon: {
      src: beef,
      alt: 'beef steak',
      width: 30,
      height: 20,
    },
    text: 'Beef',
    backgroundColor: 'background.white',
  },
  {
    component: 'illustration_pill',
    icon: {
      src: chicken,
      alt: 'chicken drumstick',
      width: 30,
      height: 20,
    },
    text: 'Chicken',
    backgroundColor: 'background.white',
  },
  {
    component: 'illustration_pill',
    icon: {
      src: turkey,
      alt: 'whole turkey',
      width: 30,
      height: 20,
    },
    text: 'Turkey',
    backgroundColor: 'background.white',
  },
  {
    component: 'illustration_pill',
    icon: {
      src: lamb,
      alt: 'lamb chop',
      width: 30,
      height: 20,
    },
    text: 'Lamb',
    backgroundColor: 'background.white',
  },
  {
    component: 'illustration_pill',
    icon: {
      src: pork,
      alt: 'pork chop',
      width: 30,
      height: 20,
    },
    text: 'Pork',
    backgroundColor: 'background.white',
  },
];

const splitListBodyData = {
  heading: {
    text: 'Benefits of a fresh food diet',
    level: 'h1',
    position: 'center',
    typography: 'heading1',
  },
  fontColor: 'text.primary',
  backgroundColor: 'neutral.bone',
  list: [
    {
      heading: 'IMPROVED DIGESTION & ENERGY',
      icon,
      headingLevel: 'h2',
      body: 'More digestible than kibble, giving your pup more nutrients and pep in their step.',
    },
    {
      heading: 'ALLERGY & WEIGHT CONTROL',
      icon,
      headingLevel: 'h2',
      body: "Our food helps maintain your pup's ideal weight and is great for allergies and sensitivities.",
    },
    {
      heading: 'MORE MEALTIMES TOGETHER',
      icon,
      headingLevel: 'h2',
      body: 'A fresh, whole food diet has been proven to help dogs live up to 2.5 years longer.',
    },
  ],
};

const ProductCardsCRO = {
  fresh: {
    icon: 'checkmarkSimple',
    gap: 0,
    typography: 'label2',
    iconColor: 'secondary.egg',
    items: [
      { body: 'Highest quality fresh ingredients' },
      { body: 'Great tasting, best for picky eaters' },
      { body: 'Increased longevity & visible health benefits' },
    ],
  },
  mixed: {
    icon: 'checkmarkSimple',
    gap: 0,
    typography: 'label2',
    iconColor: 'secondary.egg',
    items: [
      { body: 'Gently baked food retains nutrients' },
      { body: 'Health & longevity benefits of Fresh' },
      { body: 'Saves freezer space, easier for travel' },
    ],
  },
  halfFresh: {
    icon: 'checkmarkSimple',
    gap: 0,
    typography: 'label2',
    iconColor: 'secondary.egg',
    items: [
      { body: 'More affordable Fresh benefits' },
      { body: 'Human-grade ingredients' },
      { body: 'Mix with current food' },
    ],
  },
};

export const MEAL_PREP_CRO_DATA = {
  planSelectionInfo: {
    headline: "{{pupName}}'s meal plan",
    subheadline:
      "We've created a portion and plan recommendation for a {{pupWeight}}lb active pup like {{pupName}}.",
    summaryHeadline: '',
    image: '',
    ctaText: 'Select Recipes',
    items: [
      {
        title: 'Fresh',
        label: 'Select',
        benefit: 'Most Popular',
        callout: '',
        value: 'fresh',
        description: (
          <>
            <List {...ProductCardsCRO['fresh']} />
          </>
        ),
        img: {
          src: freshBowlImage.src,
          alt: 'Fresh Bowl',
        },
        unavailableText:
          'Based on your answers, this meal plan is unavailable for {{pupName}}. Please contact our Canine Care team if you have any questions.',
        priceSymbol: '',
        showMoreDetails: false,
        pricingInfo: {
          price: '{{freshPricePerWeek}}',
          discount: '{{freshDiscountPricePerWeek}}',
        },
        level: 'h3',
      },
    ],
    collapsedItems: [
      {
        title: 'Mixed',
        label: 'Select',
        benefit: 'Best Variety',
        callout: '',
        value: 'mixed',
        description: (
          <>
            <List {...ProductCardsCRO['mixed']} />
          </>
        ),
        img: {
          src: mixedBowlImage.src,
          alt: 'Mixed Bowl',
        },
        unavailableText:
          'Based on your answers, this meal plan is unavailable for {{pupName}}. Please contact our Canine Care team if you have any questions.',
        priceSymbol: '',
        showMoreDetails: false,
        pricingInfo: {
          price: '{{mixedPricePerWeek}}',
          discount: '{{mixedDiscountPricePerWeek}}',
        },
        level: 'h3',
      },
      {
        title: 'Half fresh',
        label: 'Select',
        benefit: 'Budget Friendly',
        callout: '',
        value: 'half_fresh',
        description: (
          <>
            <List {...ProductCardsCRO['halfFresh']} />
          </>
        ),
        img: {
          src: halfFreshBowlImage.src,
          alt: 'Mixed Bowl',
        },
        unavailableText:
          'Based on your answers, this meal plan is unavailable for {{pupName}}. Please contact our Canine Care team if you have any questions.',
        priceSymbol: '',
        showMoreDetails: false,
        pricingInfo: {
          price: '{{halfFreshPricePerWeek}}',
          discount: '{{halfFreshDiscountPricePerWeek}}',
        },
        level: 'h3',
      },
    ],
    mobileCtaText: 'Select Recipes',
    desktopCtaText: 'Select Recipes',
    modals: [],
    notSelectableText: '',
  },
  planSelectionInfoRecommendedPage: {
    headline: "Choose {{pupName}}'s meal plan",
    subheadline:
      'There are many plans that can work for your pup, select the option below that works best for you.',
    summaryHeadline: '',
    image: '',
    ctaText: 'Select Recipes',
    items: [
      {
        title: 'Fresh',
        label: 'Select',
        benefit: 'Most Popular',
        callout: '',
        value: 'fresh',
        description: (
          <>
            <List {...ProductCardsCRO['fresh']} />
          </>
        ),
        img: {
          src: freshBowlImage.src,
          alt: 'Fresh Bowl',
        },
        unavailableText:
          'Based on your answers, this meal plan is unavailable for {{pupName}}. Please contact our Canine Care team if you have any questions.',
        priceSymbol: '',
        showMoreDetails: false,
        pricingInfo: {
          price: '{{freshPricePerWeek}}',
          discount: '{{freshDiscountPricePerWeek}}',
        },
        level: 'h3',
      },
      {
        title: 'Mixed',
        label: 'Select',
        benefit: 'Best Variety',
        callout: '',
        value: 'mixed',
        description: (
          <>
            <List {...ProductCardsCRO['mixed']} />
          </>
        ),
        img: {
          src: mixedBowlImage.src,
          alt: 'Mixed Bowl',
        },
        unavailableText:
          'Based on your answers, this meal plan is unavailable for {{pupName}}. Please contact our Canine Care team if you have any questions.',
        priceSymbol: '',
        showMoreDetails: false,
        pricingInfo: {
          price: '{{mixedPricePerWeek}}',
          discount: '{{mixedDiscountPricePerWeek}}',
        },
        level: 'h3',
      },
    ],
    collapsedItems: [
      {
        title: 'Half fresh',
        label: 'Select',
        benefit: 'Budget Friendly',
        callout: '',
        value: 'half_fresh',
        description: (
          <>
            <List {...ProductCardsCRO['halfFresh']} />
          </>
        ),
        img: {
          src: halfFreshBowlImage.src,
          alt: 'Mixed Bowl',
        },
        unavailableText:
          'Based on your answers, this meal plan is unavailable for {{pupName}}. Please contact our Canine Care team if you have any questions.',
        priceSymbol: '',
        showMoreDetails: false,
        pricingInfo: {
          price: '{{halfFreshPricePerWeek}}',
          discount: '{{halfFreshDiscountPricePerWeek}}',
        },
        level: 'h3',
      },
    ],
    mobileCtaText: 'Select Recipes',
    desktopCtaText: 'Select Recipes',
    modals: [],
    notSelectableText: '',
  },
  body: [
    {
      component: 'Heading',
      headingLevel: 'h3',
      headingText: 'Available recipes',
      position: 'center',
      typography: 'heading3',
    },
    {
      component: 'IllustrationPills',
      pills: IllustrationPillsData,
    },
    {
      component: 'SplitScreenPromo',
      imageFirst: false,
      image: {
        src: splitScreenPromoImage,
        alt: 'Our Recipes',
      },
      contentBgColor: 'neutral.bone',
      content: (
        <>
          <SplitScreenListBody {...splitListBodyData} />
        </>
      ),
      eyebrow: '',
    },
  ],
};

export const RECOMMENDED_PLAN_CRO_DATA = {
  imageFirst: false,
  image: {
    src: splitScreenPromoImage,
    alt: 'Our Recipes',
  },
  contentBgColor: 'neutral.bone',
  content: (
    <>
      <SplitScreenListBody {...splitListBodyData} />
    </>
  ),
  eyebrow: '',
};

export const RECIPE_VARIATIONS = {
  control: 'control',
  turkey: 'turkey_first',
};

export const TURKEY_RECIPE = 'turkey';

export const HAPPINESS_QUIZ_STEPS = [
  'Name',
  'Portion',
  'Activity',
  'Happiness',
];
